import { render, staticRenderFns } from "./subLayout.vue?vue&type=template&id=28af6d0c&scoped=true"
import script from "./subLayout.vue?vue&type=script&lang=js"
export * from "./subLayout.vue?vue&type=script&lang=js"
import style0 from "./subLayout.vue?vue&type=style&index=0&id=28af6d0c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28af6d0c",
  null
  
)

export default component.exports